<template>
  <div>
    <div v-show="modoLectura === modosLectura.CODIGOBARRAS">
      <form
        class="from-busquedasCodigoBarras"
        :class="{
          'disabled-element': disabledInputs,
        }"
        @submit.prevent="CodigoBarrasLeido(valorCampoLectura)"
      >
        <f7-row>
          <f7-col width="20">
            <div class="div-modoInput">
              <div
                class="div-btnModoInput"
                @click="modoLectura = modosLectura.UNIDAD_CONTENEDORA"
              >
                <img
                  class="img-btnModoInput"
                  alt="iconCode"
                  src="@/static/icons/ic_code.svg"
                  width="50"
                  height="50"
                >
              </div>
            </div>
          </f7-col>
          <f7-col width="80">
            <div class="div-input">
              <input
                id="codigoBarras"
                ref="codigoBarras"
                class="input-searchCodeBars"
                :label="$t('common.barcode')"
                type="text"
                :placeholder="$t('common.barcode')"
                clear-button
                :disabled="disabledInputs"
                :value="valorCampoLectura"
                :inputmode="inputmode"
                @input="valorCampoLectura = $event.target.value"
              >
            </div>
          </f7-col>
        </f7-row>
      </form>
    </div>
    <div v-show="modoLectura === modosLectura.UNIDAD_CONTENEDORA">
      <form
        class="from-busquedasNumeroSerie"
        @submit.prevent="CodigoNumeroSerieLeido(valorCampoLectura)"
      >
        <f7-row>
          <f7-col width="20">
            <div class="div-modoInput">
              <div
                class="div-btnModoInput"
                @click="modoLectura = modosLectura.CODIGOBARRAS"
              >
                <img
                  class="img-btnModoInput"
                  alt="iconUnidad"
                  src="@/static/icons/ic_logistic_unit.svg"
                  width="50"
                  height="50"
                >
              </div>
            </div>
          </f7-col>
          <f7-col width="80">
            <div class="div-input">
              <input
                id="unidadContenedora"
                ref="unidadContenedora"
                class="input-busquedaCodigos"
                :label="$t('common.serialNumber')"
                type="text"
                :disabled="disabledInputs"
                :placeholder="$t('common.serialNumber')"
                :value="valorCampoLectura"
                :inputmode="inputmode"
                @input="valorCampoLectura = $event.target.value"
              >
            </div>
          </f7-col>
        </f7-row>
      </form>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import { sleep } from '@/js/utils/sleep';

export default defineComponent({
  name: 'PCCodeScannerTiposLecturas',

  props: {
    autofocusOnInput: { type: Boolean, default: false },
    modoLecturaDefecto: { type: String, default: 'uc' },
    disabled: { type: Boolean, default: false },
    inputmode: {
      type: /** @type {import('vue').PropType<HTMLAttributes['inputmode']>} */ (
        String
      ),
      default: undefined,
    },
  },

  emits: [
    'codigo-barras',
    'numero-serie',
    'focus-off',
    'focus-on',
  ],

  data() {
    return {
      modosLectura: {
        CODIGOBARRAS: 'Codigo',
        UNIDAD_CONTENEDORA: 'uc', // Unidad Logistica y Numeros De Serie
      },
      modoLectura: 'uc',
      valorCampoLectura: '', // Valor del input  para introducir datos de forma manual
      disabledInputs: false,
    };
  },

  watch: {
    async modoLectura(val) {
      this.modoLectura = val;
      if (this.autofocusOnInput) {
        await sleep(200);
        this.SetFocusOnInputElement();
      }
    },
    async disabled(value) {
      this.disabledInputs = value;
      if (!this.disabledInputs) {
        if (this.autofocusOnInput) {
          await sleep(200);
          this.SetFocusOnInputElement();
        }
      }
    },
  },

  mounted() {
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      this.EventsControlFocusInputs();
      this.modoLectura = this.modoLecturaDefecto;
      if (this.autofocusOnInput) {
        this.SetFocusOnInputElement();
      }
      this.disabledInputs = this.disabled;
    },
    EventsControlFocusInputs() {
      Log(this, this.EventsControlFocusInputs.name);
      const inputCodigoBarras = this.$refs.codigoBarras;
      const inputNumeroSeries = this.$refs.unidadContenedora;
      inputCodigoBarras.addEventListener('blur', () => {
        if (this.modoLectura === this.modosLectura.CODIGOBARRAS) {
          this.$emit('focus-off');
        }
      });
      inputNumeroSeries.addEventListener('blur', () => {
        if (this.modoLectura !== this.modosLectura.CODIGOBARRAS) {
          this.$emit('focus-off');
        }
      });
      inputCodigoBarras.addEventListener('focus', () => {
        this.$emit('focus-on');
      });
      inputNumeroSeries.addEventListener('focus', () => {
        this.$emit('focus-on');
      });
    },

    /**
     * @public
     * @returns {Promise<void>}
     */
    async SetFocusOnInputElement() {
      Log(this, this.SetFocusOnInputElement.name);
      await sleep(300);
      if (this.modoLectura === this.modosLectura.CODIGOBARRAS) {
        this.$refs.codigoBarras.focus();
      } else {
        this.$refs.unidadContenedora.focus();
      }
    },
    ResetComponent() {
      Log(this, this.ResetComponent.name);
    },
    CodigoBarrasLeido(code) {
      Log(this, this.CodigoBarrasLeido.name);
      this.$emit('codigo-barras', code);
      this.valorCampoLectura = '';
      if (this.autofocusOnInput) {
        this.SetFocusOnInputElement();
      }
    },
    CodigoNumeroSerieLeido(code) {
      Log(this, this.CodigoNumeroSerieLeido.name);
      this.$emit('numero-serie', code);
      this.valorCampoLectura = '';
      if (this.autofocusOnInput) {
        this.SetFocusOnInputElement();
      }
    },

  },
});
</script>

<style scoped lang="scss">
.md .fab[class*="-bottom"] {
  position: fixed;
}

.md .fab > a,
.md .fab-buttons a {
  color: #fff;
  background: #66ba33;
  padding: 5px;
  min-width: 200px;
}

.disabled-element {
  opacity: 0.5;
  pointer-events: none;
}

.img-iconoFab {
  float: left;
  position: absolute;
  left: 6px;
}

.fab-text {
  padding-left: 12%;
}

block-btn-camera {
  display: flex;
  align-items: center;
  justify-content: center;

  .btn-camara {
    color: #fff;
    min-width: 200px;
  }
}

.page {
  background: var(--his-tierra-white);
}

.div-animacionBarCode {
  display: flex;
  text-align: center;
  align-items: center;
}

/** Animation bar-code **/
.center {
  margin: 0 auto;
  text-align: center;
}

.spacer {
  margin-top: 6rem;
}

.anim-box {
  position: relative;
  width: 220px;
  height: 100px;
  padding: 25px 30px;
}

.anim-box::before,
.anim-box::after,
.anim-box > :first-child::before,
.anim-box > :first-child::after {
  position: absolute;
  width: 10%;
  height: 15%;
  border-color: #fff;
  border-style: solid;
  content: " ";
}

.anim-box::before {
  top: 0;
  left: 0;
  border-width: 2px 0 0 2px;
}

.anim-box::after {
  top: 0;
  right: 0;
  border-width: 2px 2px 0 0;
}

.anim-box > :first-child::before {
  bottom: 0;
  right: 0;
  border-width: 0 2px 2px 0;
}

.anim-box > :first-child::after {
  bottom: 0;
  left: 0;
  border-width: 0 0 2px 2px;
}

.anim-item {
  display: inline-block;
  background-color: #282829;
  height: 100px;
}

.anim-item-sm {
  width: 2px;
  margin-right: 3px;
}

.anim-item-md {
  width: 3px;
  margin-right: 2px;
}

.anim-item-lg {
  width: 5px;
  margin-right: 5px;
}

.scanner {
  width: 100%;
  height: 3px;
  background-color: red;
  opacity: 0.7;
  position: relative;
  box-shadow: 0 0 8px 10px rgb(170 11 23 / 49%);
  top: 50%;
  animation-name: scan;
  animation-duration: 4s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

@keyframes scan {
  0% {
    box-shadow: 0 0 8px 10px rgb(170 11 23 / 49%);
    top: 50%;
  }

  25% {
    box-shadow: 0 6px 8px 10px rgb(170 11 23 / 49%);
    top: 5px;
  }

  75% {
    box-shadow: 0 -6px 8px 10px rgb(170 11 23 / 49%);
    top: 98%;
  }
}

.div-input {
  background: #fff;
  margin-right: 18px;
  margin-left: 18px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  min-height: 60px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.input-searchCodeBars {
  width: 100%;
  height: 100%;
  padding-left: 19px;
  padding-right: 19px;
  color: #24253da8;
  font-size: 17px;
  margin-top: 22px;
  margin-bottom: 16px;
}

.input-busquedaCodigos {
  width: 100%;
  height: 100%;
  padding-left: 19px;
  padding-right: 19px;
  color: #24253da8;
  font-size: 17px;
  margin-top: 22px;
}

.div-modoInput {
  margin-top: 16px;
  margin-bottom: 0;
}

.div-btnModoInput {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  margin-left: 15px;
  border: 1px solid var(--his-silver);
  border-radius: 8px;
  height: 100%;
  width: 100%;
  min-height: 58px;
  box-shadow: 0 6px 10px #6666662b;
}

.img-btnModoInput {
  min-height: 36px;
  width: 45%;
}
</style>
